<template>
  <div>
    <div>
      <span v-if="seat.class === 'mesa'" class="tooltip-text-title"
        >Mesa
        {{
          seat.identificacao && String(seat.identificacao).includes("MESA")
            ? seat.identificacao.split("-")[1]
            : seat.identificacao.replace("Mesa", "")
        }}</span
      >
      <span
        v-else-if="
          seat.class !== 'mesa' &&
          seat.identificacao &&
          String(seat.identificacao).includes('Mesa')
        "
        class="tooltip-text-title"
        >Mesa
        {{ seat.identificacao.replace("Mesa", "").split(";")[0] }}
        Cadeira
        {{ seat.identificacao.replace("Mesa", "").split(";")[1] }}</span
      >
      <span
        v-else-if="
          seat.class !== 'mesa' &&
          seat.identificacao &&
          String(seat.identificacao).includes('MESA')
        "
        class="tooltip-text-title"
        >{{ seat.identificacao.split("-")[1] }}</span
      >
      <span v-else class="tooltip-text-title"
        >{{ seat.identificacao | getRow }}
        {{ seat.identificacao | getNumber }}</span
      >
      <br />
      <span class="tooltip-text" v-if="!seat.disponivel">Indisponível</span>
      <span class="tooltip-text" v-if="seat.disponivel && seat.tipo !== '9'">{{
        seat.nome_produto_vinculado
      }}</span>
      <br v-if="seat.tipo !== '9'" />
      <span class="tooltip-text" v-if="seat.disponivel">
        {{ seat.tipo === "9" ? "Total: " : "" }}
        {{ showPriceRange(seat) }}
      </span>
    </div>
    <v-row
      v-if="
        seat.disponivel &&
        seat.produto_vinculado &&
        getProductDetails(seat) &&
        getProductDetails(seat).valor_consumacao_lote
      "
      no-gutters
    >
      <span class="tooltip-text">
        Consumação:
        {{ getProductDetails(seat).valor_consumacao_lote | currency }}
      </span>
    </v-row>
    <v-row
      v-if="
        seat.disponivel && seat.produto_vinculado && getProductDetails(seat)
      "
      no-gutters
    >
      <span class="tooltip-text">{{
        getProductDetails(seat).observacoes
      }}</span>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["seat"],

  computed: {
    ...mapGetters(["selectedSeat", "selectedSector", "cartProducts"]),
  },

  filters: {
    getNumber: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.split(";").pop();
    },
    getRow: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.split(";").shift();
    },
  },

  methods: {
    getProductDetails(seat) {
      let findedProduct = this.selectedSector.products.find(
        (t) => seat.produto_vinculado === t.codigo_produto
      );

      if (findedProduct) return findedProduct;
      else return "";
    },

    showPriceRange(seat) {
      return this.rangeByType(
        this.selectedSector.products.filter(
          (t) => seat.produto_vinculado === t.codigo_produto
        )
      );
    },

    rangeByType(productTypes) {
      let min = Number.MAX_SAFE_INTEGER;
      let max = Number.MIN_SAFE_INTEGER;

      productTypes.forEach((type) => {
        if (!type.encerrado) {
          const value = type.valor + type.valor_conveniencia;
          if (min > value) {
            min = value;
          }

          if (max < value) {
            max = value;
          }
        }
      });

      if (max === Number.MIN_SAFE_INTEGER && min === Number.MAX_SAFE_INTEGER) {
        max = 0;
        min = 0;
        return "";
      }
      min = this.$options.filters.currency(min);
      max = this.$options.filters.currency(max);
      return min !== max ? `De ${min} a ${max}` : `${min}`;
    },
  },
};
</script>
